<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="assessment_type_list" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Assessment Type</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="1" cols="12"> </v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Assessment Type</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" v-if="editedIndex == -1">
                                                    <v-autocomplete v-model="editedItem.assessmentType"
                                                        label="Assessment Type"
                                                        :items="assessment_type_super_master_list"
                                                        :disabled="editedIndex != -1" persistent-hint :hint="editedIndex == -1
                                                            ? 'Select Assessment Type :: Class Test, End Sem Exam etc'
                                                            : 'noneditable'
                                                            " :filled="editedIndex == -1 ? false : true"
                                                        :error="errorMsg.assessmentType ? true : false" :error-messages="errorMsg.assessmentType ? 'Required' : ''
                                                            " :rules="[(v) => !!v || 'required']"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-text-field v-model="editedItem.assessmentType" persistent-hint
                                                        :disabled="editedIndex != -1" :hint="editedIndex == -1
                                                            ? 'Select Assessment Type :: Class Test, End Sem Exam etc'
                                                            : 'noneditable'
                                                            "
                                                        :filled="editedIndex == -1 ? false : true"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.assessment_display_name"
                                                        label="Display Name"
                                                        hint="For Example, Class Test :: CT , End Sem Exam :: ESE"
                                                        :rules="[(v) => !!v || 'required']"
                                                        ref="assessment_display_name"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.assessment_alternate_name"
                                                        label="Alternate Name"
                                                        hint="For Example, Class Test :: CT , End Sem Exam :: ESE"
                                                        :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active?"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col v-if="editedIndex == -1">
                                                    <v-checkbox dense v-model="newassessmentTypecheckbox"
                                                        color="success"
                                                        label="Assessment Type not present in above list? Add new here..."></v-checkbox>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12"
                                                    v-if="editedIndex == -1 && newassessmentTypecheckbox">
                                                    <v-text-field v-model="newassessment_type" persistent-hint
                                                        hint="For example ::Class Test, End Sem Exam etc"
                                                        label="New Assessment Type"
                                                        ref="newassessment_type"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="newassessmentTypecheckbox">
                                                    <v-btn class="mb-2 button" color="primary" small
                                                        @click="savenewassessment_type">Save New
                                                        Assessment Type</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <!-- <template v-slot:no-data>
    <v-btn color="primary" @click="initialize">Reset</v-btn>
  </template> -->
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },


    data: () => ({
        valid: false,
        assessment_type_super_master_list: "",
        // extraBreadcrumbItems: [
        //     { text: "Assessment Type", disabled: true, href: "" },

        // ],
        // breadcrumbClass: "breadcrumb-style1",

        // country_super_master_list_nationality: '',
        newassessment_type: "",
        overlay: false,
        errorMsg: {
            assessmentType: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        newassessmentTypecheckbox: false,
        search: "",
        dialog: false,
        assessment_type_super_master_list: null,
        headers: [
            {
                text: "Assessment Type",
                align: "left",
                sortable: false,
                value: "assessmentType",
            },
            {
                text: "Display Name",
                align: "left",
                sortable: false,
                value: "assessment_display_name",
            },
            {
                text: "Altername Name",
                align: "left",
                sortable: false,
                value: "assessment_alternate_name",
            },
            {
                text: "Active",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
        ],
        assessment_type_list: [],
        editedIndex: -1,
        addedItem: {
            assessment_type_super_master_list: "",
            //country_super_master_list_nationality: '',
        },
        editedItem: {
            assessmentTypeId: "",
            assessment_display_name: "",
            assessmentType: "",
            isactive: true,
            assessment_alternate_name: "",
        },
        defaultItem: {
            assessmentTypeId: "",
            assessment_display_name: "",
            assessmentType: "",
            isactive: true,
            assessment_alternate_name: "",
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Assessment Type" : "Edit Assessment Type";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },

    // created () {
    //   this.initialize()
    // },
    mounted() {
        this.onLoad();
    },
    methods: {
        savenewassessment_type() {
            if (this.editedItem.assessment_display_name.length == 0) {
                this.showSnackbar("#b71c1c", "Please Enter Assessment Display Name..!");
                this.$refs["assessment_display_name"].focus();
                return;
            }
            if (this.newassessment_type.length == 0) {
                this.showSnackbar("#b71c1c", "Please Enter Assessment Type Name..!");
                this.$refs["newassessment_type"].focus();
                return;
            }
            let data = {
                newassessment_type: this.newassessment_type,
                assessment_display_name: this.editedItem.assessment_display_name,
                isactive: this.editedItem.isactive,
            };
            this.overlay = true;
            axios
                .post("/AdmissionMaster/addAssessmentType", data)
                .then((res) => {
                    (this.newcast = ""),
                        (this.newassessmentTypecheckbox = false),
                        (this.overlay = false);
                    if (res.data.status.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Assessment Type Added Successfully!!!"); // show snackbar on success
                        this.onLoad();
                    } else if (res.data.status.code == "NA") {
                        this.showSnackbar("#b71c1c", "Assessment Type Already Present!"); // show snackbar on error
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
            this.close();
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
            (this.newassessment_type = ""), (this.newassessmentTypecheckbox = false);
        },
        editItem(item) {
            this.editedIndex = this.assessment_type_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/Examination/assessmentType")
                .then((res) => {
                    if (res.data.msg == "200") {
                        //window.alert(res.data.msg)

                        if ((this.load = true)) {
                            this.overlay = false;
                            this.assessment_type_list = res.data.assessment_type_list;
                            this.assessment_type_super_master_list = res.data.assessment_type_super_master_list;
                        }
                    } else {
                        window.console.log(res.data.msg);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    "use strict";
                    var overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        // deleteItem (item) {
        //   const index = this.country_master_list.indexOf(item)
        //   confirm('Are you sure you want to delete this item?') && this.country_master_list.splice(index, 1)
        // },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/Examination/editAssessmentType", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                //window.alert(res.data.msg)
                                Object.assign(this.assessment_type_list[this.editedIndex], this.editedItem);
                            }
                            this.showSnackbar("#4caf50", "Assessment Type Updated Successfully..."); // show snackbar on success
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                //this.country_master_list.push(this.editedItem)
                axios
                    .post("/Examination/saveAssessmentType", this.editedItem)
                    .then((res) => {
                        if (res.data.status.code == "SUCCESS") {
                            //window.alert(res.data.status.code)
                            this.assessment_type_list.push(this.addedItem);
                            this.showSnackbar("#4caf50", "Assessment Type Added Successfully!!!"); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.status.code == "NA") {
                            //window.alert(res.data.status.code)
                            //alert(res.data.status.message)
                            this.showSnackbar("#b71c1c", "Assessment Type Already Present!!!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
        }, //save()
        isValidated() {
            if (this.editedItem.assessmentType) {
                return true;
            } else {
                if (!this.editedItem.assessmentType) {
                    this.errorMsg.assessmentType = true;
                }

                return false;
            }
        }, // .....end of isValidated()
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
